import React, { Fragment, useState } from 'react';
import { Helmet } from 'react-helmet';
import moment from 'moment';
import axios from 'axios';
import { isEmpty } from 'lodash-es';
import {
  Alert,
  Button,
  Input,
  CheckboxGroup,
  Checkbox,
} from 'chaoskit/src/components';
import isEmail from 'validator/lib/isEmail';

const FreeSignupForm = () => {
  const [errors, setErrors] = useState({});
  const [inputs, setInputs] = useState({ requestedDemo: false });
  const [isLoading, setLoading] = useState(false);
  const [response, setResponse] = useState();

  const handleChange = (name, value) => {
    setInputs(currentInputs => ({ ...currentInputs, [name]: value }));
  };

  const handleDemoCheckboxChange = (name, value, checked) => {
    setInputs(currentInputs => ({ ...currentInputs, [name]: checked }));
  };

  const validateForm = () => {
    const formErrors = {};

    if (!inputs.email) {
      formErrors.email = 'Work Email is required';
    } else if (!isEmail(inputs.email)) {
      formErrors.email = 'Invalid email';
    }

    if (!inputs.firstName) {
      formErrors.firstName = 'First Name is required';
    }

    if (!inputs.lastName) {
      formErrors.lastName = 'Last Name is required';
    }

    return formErrors;
  };

  const handleSubmit = () => {
    const formErrors = validateForm();

    if (!isEmpty(formErrors)) {
      setErrors(formErrors);

      return;
    }

    // Otherwise clear errors and submit form
    setErrors({});
    setLoading(true);

    axios
      .post('https://api.gremlin.com/v1/companies/invites/free', {
        admin_email: inputs.email,
        first_name: inputs.firstName,
        last_name: inputs.lastName,
        requested_demo: inputs.requestedDemo,
      })
      .then(() => {
        if (window.fbq) {
          window.fbq('track', 'CompleteRegistration');
        }

        if (window.gtag) {
          window.gtag('event', 'Submit', {
            event_category: 'Free Sign Up',
            event_label: 'Account Created',
          });

          window.gtag('event', 'conversion', {
            send_to: 'AW-824675656/RzDPCJOejZYBEMianokD',
          });
        }

        if (window.clearbit) {
          window.clearbit.identify(inputs.email, { email: inputs.email });
        }

        // Only fire ChiliPiper if they selected a demo request
        if (inputs.requestedDemo && window.ChiliPiper) {
          window.ChiliPiper.submit('gremlin', 'free-router', {
            lead: {
              email: inputs.email,
              FirstName: inputs.firstName,
              LastName: inputs.lastName,
              requestedDemo: inputs.requestedDemo,
              Chili_Piper_Date: moment().format('LLLL'),
            },
          });
        }

        setLoading(false);
        setResponse('success');
      })
      .catch(() => {
        setLoading(false);
        setResponse('error');
      });
  };

  return (
    <Fragment>
      <Helmet>
        <script src="https://js.chilipiper.com/marketing.js" />
      </Helmet>
      <h3 className="u-textFluid--xlarge u-mb--large u-textCenter u-textLeft@medium">
        Sign up for free
      </h3>
      {response === 'success' ? (
        <Alert type="primary" title="Success!">
          <p>Activation link sent to {inputs.email}</p>
        </Alert>
      ) : (
        <form>
          <Input
            label="First Name"
            name="firstName"
            onChange={handleChange}
            validationMessage={errors.firstName}
          />
          <Input
            label="Last Name"
            name="lastName"
            onChange={handleChange}
            validationMessage={errors.lastName}
          />
          <Input
            label="Work Email"
            name="email"
            onChange={handleChange}
            validationMessage={errors.email}
          />
          <div className="signup__footer">
            <div>
              <CheckboxGroup inline>
                <Checkbox
                  name="requestedDemo"
                  onChange={handleDemoCheckboxChange}
                  label="I'd also like someone to contact me to schedule a demo of Gremlin."
                  value="demo"
                />
              </CheckboxGroup>
            </div>
            <div>
              <Button type="primary" loading={isLoading} onClick={handleSubmit}>
                Sign Up
              </Button>
            </div>
          </div>
        </form>
      )}
    </Fragment>
  );
};

export default FreeSignupForm;
